import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../_metronic/helpers'
import {Company, CompanyQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const USER_URL = `${API_URL}/companies`
const STATUS_UPDATE_URL = `${API_URL}/users/update-status`
const GET_USERS_URL = `${API_URL}/companies`
const ADMIN_AUTH = `${API_URL}/admin/auth/update/password`
const USERS_URL = `${API_URL}/companies`

const getUsers = (query: string): Promise<CompanyQueryResponse> => {
  return axios
    .get(`${GET_USERS_URL}?${query}`)
    .then((d: AxiosResponse<CompanyQueryResponse>) => d.data)
}

const getUserById = (id: ID): Promise<Company | undefined> => {
  return axios
    .get(`${USER_URL}/${id}`)
    .then((response: AxiosResponse<Response<Company>>) => response.data)
    .then((response: Response<Company>) => response.data)
}

const createCompany = (user: Company): Promise<any> => {
      return axios
    .post(USERS_URL, user)
    .then((response: AxiosResponse<Response<any>>) => response.data)
    .then((response: Response<any>) => response.data)
}

const updateUserDetail = (user: Company): Promise<Company | undefined> => {
  return axios
    .patch(`${GET_USERS_URL}/${user._id}`, user)
    .then((response: AxiosResponse<Response<Company>>) => response.data)
    .then((response: Response<Company>) => response.data)
}

const updateUser = (user: Company): Promise<Company | undefined> => {
  return axios
    .patch(`${STATUS_UPDATE_URL}/${user._id}`, user)
    .then((response: AxiosResponse<Response<Company>>) => response.data)
    .then((response: Response<Company>) => response.data)
}

const updatePassword = (user: Company): Promise<Company | undefined> => {
  
  return axios
    .post(`${ADMIN_AUTH}/${user._id}`, user)
    .then((response: AxiosResponse<Response<Company>>) => response.data)
    .then((response: Response<Company>) => response.data)
}

const deleteCompany = (userId: ID): Promise<void> => {
  return axios.delete(`${USER_URL}/${userId}`).then(() => {})
}





const deleteSelectedUsers = (userIds: Array<ID>): Promise<void> => {
  const requests = userIds.map((id) => axios.delete(`${USER_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {getUsers, deleteCompany, deleteSelectedUsers, getUserById, createCompany, updateUser,updateUserDetail,updatePassword}
